var _rect, _path, _path2, _g, _g2, _ellipse, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchPhoneNumberDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Switch_Phonenumber",
    "data-name": "Switch Phonenumber",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1327",
    "data-name": "Rectangle 1327",
    width: 18,
    height: 18,
    fill: "#787f88",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M5.22,12.16H1.84a1.049,1.049,0,0,1-.96-1.12v-9A1.049,1.049,0,0,1,1.84.92H6.63a1.049,1.049,0,0,1,.96,1.12",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M12.45,5.81h3.74a1.049,1.049,0,0,1,.96,1.12v8.99a1.049,1.049,0,0,1-.96,1.12H11.4a1.049,1.049,0,0,1-.96-1.12",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "repeat-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    d: "M6.06,7.61,7,6.33l.98,1.25",
    fill: "none",
    stroke: "#f49b31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    d: "M7.01,6.76l.07,5.47a1.922,1.922,0,0,0,1.63,2.09h.32m2.52-3.4-.94,1.28-.98-1.25",
    fill: "none",
    stroke: "#f49b31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    d: "M10.6,11.76l-.07-5.47A1.922,1.922,0,0,0,8.9,4.2H8.58",
    fill: "none",
    stroke: "#f49b31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.22
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 0.85,
    cy: 0.62,
    rx: 0.85,
    ry: 0.62,
    transform: "translate(3.49 0.92)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1328",
    "data-name": "Rectangle 1328",
    width: 3.08,
    height: 0.79,
    rx: 0.39,
    transform: "translate(2.8 10.12)",
    fill: "#165cf3"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 0.85,
    cy: 0.62,
    rx: 0.85,
    ry: 0.62,
    transform: "translate(12.98 5.69)",
    fill: "#165cf3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1329",
    "data-name": "Rectangle 1329",
    width: 3.08,
    height: 0.79,
    rx: 0.39,
    transform: "translate(12.29 14.9)",
    fill: "#165cf3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchPhoneNumberDarkIcon);
export default __webpack_public_path__ + "static/media/switch-phone-number-dark-icon.369017e2f758e6064f2fbb9c521b5087.svg";
export { ForwardRef as ReactComponent };